import React from "react"
import { useTranslation } from "react-i18next"

import { Card } from "~/components/Card/Card"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"

import { SendTreatment } from "../PopupSendTreatment/PopupSendTreatment"
import styles from "./index.module.css"

export const TreatmentOrder: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Card className={styles.Wrapper}>
      <Heading className={styles.Title} like="h5">
        <Raw html={t("conflictCommission.TreatmentOrder.Title")} />
      </Heading>

      <ol>
        <li>
          <div>
            <Raw html={t("conflictCommission.TreatmentOrder.Steps.01")} />
          </div>
          <div className={styles.Download}>
            <a
              href="/upload/forma_zhaloby_v_konfliktnuiu_komissiiu.docx"
              rel="noopener noreferrer"
              target="_blank"
            >
              <Raw html={t("conflictCommission.TreatmentOrder.Download")} />
            </a>{" "}
            <span>
              <Raw html={t("conflictCommission.TreatmentOrder.Download.Size")} />
            </span>
          </div>
        </li>
        <li>
          <Raw html={t("conflictCommission.TreatmentOrder.Steps.02")} />
        </li>
        <li>
          <Raw html={t("conflictCommission.TreatmentOrder.Steps.03")} />
        </li>
      </ol>

      <div className={styles.Button}>
        <SendTreatment />
      </div>
    </Card>
  )
}
